// Lets floating UI (chat widget, sticky mobile CTA) fully unmount while the
// Razorpay checkout overlay is open on top of the page, and restore once it
// closes (success, cancel, or failure) - avoids any fixed-position/transform
// element sitting above or intercepting taps on Razorpay's own overlay,
// especially on mobile Safari/Chrome.
const OPEN_EVENT = "amtm:checkout-open";
const CLOSE_EVENT = "amtm:checkout-close";

export function dispatchCheckoutOpen() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}

export function dispatchCheckoutClose() {
  window.dispatchEvent(new Event(CLOSE_EVENT));
}

export function subscribeToCheckoutVisibility(onOpen, onClose) {
  window.addEventListener(OPEN_EVENT, onOpen);
  window.addEventListener(CLOSE_EVENT, onClose);
  return () => {
    window.removeEventListener(OPEN_EVENT, onOpen);
    window.removeEventListener(CLOSE_EVENT, onClose);
  };
}
